// extracted by mini-css-extract-plugin
export default {"card":"cards_card__nXpkl","btnn":"cards_btnn__4F6rJ"};